import menuInit from './menu';
import navbarInit from './navbar';

document.addEventListener('DOMContentLoaded', () => {
  import(/* webpackPrefetch: true */ './icons');
  menuInit();
  navbarInit();

  const headerElements = document.getElementsByClassName('header');

  [...headerElements].forEach((headerElement: HTMLElement) => {
    import('./header').then((module) => module.default(headerElement));
  });

  if (document.getElementsByClassName('mobile-menu').length) {
    import('./menu').then((module) => module.default());
  }

  if (document.getElementsByClassName('slider').length) {
    import('./slider').then((module) => module.default());
  }
  if (document.getElementsByClassName('upload').length) {
    import('./upload').then((module) => module.default());
  }
  if (document.getElementsByClassName('faq__item').length) {
    import('./faq').then((module) => module.default());
  }
  if (document.getElementsByClassName('sb-sidebar').length) {
    import('./filter').then((module) => module.default());
  }
  if (document.getElementsByClassName('wc-predefined-quantity').length) {
    import('./predefinedQuantity').then((module) => module.default());
  }
  if (document.getElementsByClassName('add-to-cart-button').length) {
    import('./add-to-cart').then((module) => module.default());
  }
  if (document.getElementsByClassName('wc-block-product-categories-list--depth-1').length) {
    import('./woo-cats').then((module) => module.default());
  }
});
